export default __webpack_public_path__ + "b2f4ab15e32856c85c8ba2f1f71d0fd1.png";